export enum ActivityTransactionTypeEnum {
    RECEIVED = 1,
    SPENT = 2
}
